export default function getInitState() {
    return {
        dataTableOptions: {
            initOnRender: false
        },
        actionsPTBT: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'search'
            }
        ],
        formActions: [],
        rowActions: [],
        headerFieldsPTBT: [
            {
                name: "treatmentTitle",
                label: "Kezelés fajta",
                filter: {
                    type: "simple",
                },
                visibility: true,

            },
            {
                name: "patientCount",
                label: "Betegforgalom",
                filter: {
                    type: "simple",
                },
                visibility: true,

            }
        ]
    }
}
